/* Builds the 3D pergola. Returns the camera distance and target height. */
window.PCBuild = function (THREE, group, st, cfg, fx) {
  var W = st.w, D = st.d, H = st.h, p = 0.12, bm = 0.16;
  var sty = cfg.styles[st.style], wall = sty && sty.wall;
  function hex(list, i, def) { return (list[i] || { hex: def }).hex; }
  function std(c, r, m, extra) {
    var o = { color: c, roughness: r, metalness: m };
    if (extra) for (var k in extra) o[k] = extra[k];
    return new THREE.MeshStandardMaterial(o);
  }
  var frameHex = hex(cfg.frames, st.frame, '#383e42');
  var slatHex = hex(cfg.slats, st.slat, '#f0efea');
  var frame = std(frameHex, 0.45, 0.35);
  var slat = std(slatHex, 0.5, 0.3);
  var wallMat = std('#e4ddd0', 0.9, 0);
  var deckMat = std('#cfc7b8', 0.95, 0);

  function box(w, h, d, x, y, z, m) {
    var mesh = new THREE.Mesh(new THREE.BoxGeometry(w, h, d), m || frame);
    mesh.position.set(x, y, z);
    mesh.castShadow = true; mesh.receiveShadow = true;
    group.add(mesh);
    return mesh;
  }

  box(W + 1, 0.06, D + 1, 0, 0.03, 0, deckMat).castShadow = false;
  var xs = [-(W / 2 - p / 2), (W / 2 - p / 2)];
  var zf = D / 2 - p / 2, zb = -D / 2 + p / 2;
  xs.forEach(function (x) { box(p, H, p, x, H / 2, zf); });
  if (wall) {
    box(W + 0.8, H + 0.5, 0.2, 0, (H + 0.5) / 2, -D / 2 - 0.15, wallMat);
  } else {
    xs.forEach(function (x) { box(p, H, p, x, H / 2, zb); });
  }
  box(W, bm, p, 0, H - bm / 2, zf);
  box(W, bm, p, 0, H - bm / 2, zb);
  xs.forEach(function (x) { box(p, bm, D, x, H - bm / 2, 0); });

  var n = Math.max(4, Math.round(D / 0.2));
  var span = (D - 2 * p) / n;
  for (var i = 0; i < n; i++) {
    var z = -D / 2 + p + (i + 0.5) * span;
    box(W - 2 * p, 0.035, span * 0.88, 0, H - bm / 2 + 0.02, z, slat).rotation.x = 0.7;
  }

  /* Electric blinds */
  if (fx.blinds) {
    var bh = H - bm - 0.12, by = 0.08 + bh / 2, s = fx.blinds.sides;
    var bmat = std(fx.blinds.hex, 0.9, 0, { transparent: true, opacity: 0.94, side: THREE.DoubleSide });
    if (s.front) box(W - 2 * p, bh, 0.03, 0, by, zf, bmat);
    if (s.back && !wall) box(W - 2 * p, bh, 0.03, 0, by, zb, bmat);
    if (s.left) box(0.03, bh, D - 2 * p, xs[0], by, 0, bmat);
    if (s.right) box(0.03, bh, D - 2 * p, xs[1], by, 0, bmat);
  }

  /* LED lighting */
  group.userData.tick = null;
  if (fx.led) {
    var ledMat = new THREE.MeshBasicMaterial({ color: 0xffffff });
    var yL = H - bm - 0.02;
    var strips = [
      box(W - 2 * p, 0.035, 0.045, 0, yL, zf - 0.09, ledMat),
      box(W - 2 * p, 0.035, 0.045, 0, yL, zb + 0.09, ledMat),
      box(0.045, 0.035, D - 2 * p - 0.2, xs[0] + 0.09, yL, 0, ledMat),
      box(0.045, 0.035, D - 2 * p - 0.2, xs[1] - 0.09, yL, 0, ledMat)
    ];
    strips.forEach(function (m) { m.castShadow = false; });
    var lights = [-D / 4, D / 4].map(function (zz) {
      var l = new THREE.PointLight(0xffffff, 0.9, 7);
      l.position.set(0, H - 0.45, zz);
      group.add(l);
      return l;
    });
    var tmp = new THREE.Color();
    function setCol(c) { ledMat.color.copy(c); lights.forEach(function (l) { l.color.copy(c); }); }
    if (fx.led === 'rgb') {
      setCol(tmp.setHSL(0, 1, 0.55));
      group.userData.tick = function (t) { setCol(tmp.setHSL((t * 0.00008) % 1, 1, 0.55)); };
    } else {
      setCol(tmp.set(fx.led === 'cold' ? '#cfe6ff' : '#ffb04a'));
    }
  }

  return { r: Math.sqrt(W * W + D * D) * 1.1 + H * 1.3 + 1.5, tY: H * 0.45 };
};